module.exports = __webpack_public_path__ + "static/media/kenzie-hub.8cc3650b.png";